export default __webpack_public_path__ + "static/media/BurnH.bc3a3033.svg";